// extracted by mini-css-extract-plugin
export var centeredContent = "r_bc";
export var heroWithTitle = "r_8";
export var pageContent = "r_w";
export var starIcon = "r_bb";
export var subtitleContainer = "r_9";
export var titleContainer = "r_4";